export default __webpack_public_path__ + "static/media/vastaanotto-darkblue.abe1a6d7.svg";